import { render, staticRenderFns } from "./ModalEditComment.vue?vue&type=template&id=59bf09f4"
import script from "./ModalEditComment.vue?vue&type=script&lang=js"
export * from "./ModalEditComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports